<!--
 * @Author: 欧阳铭山
 * @Date: 2022-06-22 17:08:44
 * @LastEditors: 杨道博
 * @LastEditTime: 2022-08-02 14:00:35
 * @Description: Description
 
 * @FilePath: \ys.fxkh_yzt\src\App.vue
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
</style>
